import {AbstractEvent} from "@/modules/base/events";
import {Player} from "@/modules/team/entity";

export class AfterTrainingProgressEvent extends AbstractEvent {
  constructor(
    public player: Player,
    public totalProgress: number,
    public energyReduction: number,
  ) {
    super();
  }
}